export default __webpack_public_path__ + "static/media/T9.67964de7.jpeg";